<template>
    <div class="jumbotron" style="display:none">
        <h4 class="display-4"><i class="fas fa-cogs"></i> Settings</h4>
        <form class="form">
            <div class="form-group" v-if="hasAudioInputOptions">
                <DeviceSelect :key="'audioInputId'" :kind="'audioinput'" :label="'Audio Input Source'" :devices="devices"
                    @settingsChanged="onSettingsChanged($event)" />
            </div>
            <div class="form-group" v-if="hasAudioOutputOptions">
                <DeviceSelect :key="'audioOutputId'" :kind="'audiooutput'" :label="'Audio Output Source'" :devices="devices"
                    @settingsChanged="onSettingsChanged($event)" />
            </div>
            <div class="form-group" v-if="devices.length > 0">
                <DeviceSelect ref="video" :KeyData="'videoInputIdData'" :kind="'videoinput'" :label="'Video Input Source'"
                    :devices="devices" @settingsChanged="onSettingsChanged($event)" />
            </div>
        </form>
        <div :style="{ display: isPreviewing ? 'block' : 'none' }">
            <Camera ref="camera" />
        </div>
    </div>
    <!-- </div> -->
</template>

<script>
import DeviceService from "@/service/crmservice/deviceservice";
import { ref, onMounted } from "vue";
import DeviceSelect from "../settings/device-select.vue"
import Camera from "../camera/camera.vue"
export default ({
    name: 'settings',
    components: {
        DeviceSelect,
        Camera
    },
    props: {
        isPreviewing: Boolean
    },
    setup(props, ctx) {

         //====================== Variable ===========================

        const deviceService = ref(new DeviceService());
        const settingsChanged = ref(null);
        const devices = ref([]);
        const subscription = ref("");
        const videoDeviceId = ref("");
        const camera = ref(null);
        const video = ref(null);


         //====================== Funcations ===========================

        const getDevices = async () => {
            if (navigator && navigator.mediaDevices) {
                navigator.mediaDevices.ondevicechange = (data) => {
                }

                await deviceService.value.getDeviceOptions().then((deviceListPromise) => {
                    devices.value = deviceListPromise;
                    if (devices.value) {
                        handleDeviceAvailabilityChanges();
                    }

                })
            }

        }

        const onSettingsChanged = (deviceInfo) => {
            ctx.emit("settingsChanged", deviceInfo);
        }

        const showPreviewCamera = async () => {
            try {
                props.isPreviewing = true;
                if (!camera.value.videoTrack && videoDeviceId.value !== video.value.selectedId) {
                    videoDeviceId.value = video.value.selectedId;
                    const videoDevice = devices.value.find(d => d.deviceId === video.value.selectedId);
                    await camera.value.initializePreview(videoDevice.deviceId);
                } else {
                    await camera.value.initializePreview(null);
                }
            } catch (e) {
                await camera.value.initializePreview(null);
            }

            return camera.value.videoTrack;
        }

        const hidePreviewCamera = () => {
            props.isPreviewing = false;
            camera.value.finalizePreview();
            return devices.value.find(d => d.deviceId === video.value.selectedId);
        }

        const handleDeviceAvailabilityChanges = () => {
            if (devices.value && devices.value.length && video.value && video.value.selectedId) {
                let videoDevice = devices.value.find(d => d.deviceId === video.value.selectedId);
                if (!videoDevice) {
                    videoDevice = devices.value.find(d => d.kind === 'videoinput');
                    if (videoDevice) {
                        video.value.selectedId = videoDevice.deviceId;
                        onSettingsChanged(videoDevice);
                    }
                }
            }
        }

        //====================== onMounted ===========================

        onMounted(() => {
            getDevices();
        });

        //====================== return ===========================

        return {
            videoDeviceId,
            subscription,
            devices,
            video,
            camera,
            settingsChanged,
            handleDeviceAvailabilityChanges,
            getDevices,
            onSettingsChanged,
            showPreviewCamera,
            hidePreviewCamera,
            handleDeviceAvailabilityChanges,
        }
    },
})
</script>

<style scoped>
div.jumbotron {
    background-color: transparent;
}

button>i {
    padding-right: 6px;
}

label {
    font-size: 1.25rem;
}
</style>
